import { lazy, Suspense } from "react";
import {
    ERROR_PAGE_404_PATH,
    MAIN_PATH,
    SIGNIN_PATH,
    SIGNUP_PATH,
    RULES_PATH,
    FORGOT_PASSWORD_PATH,
} from "./path";
import { Loader } from "components/general";

const SignInPage = lazy(() => import("pages/public/SignIn/SignIn"));
const SignUpPage = lazy(() => import("pages/public/SignUp/SignUp"));
const ForgotPasswordPage = lazy(() =>
    import("pages/public/ForgotPassword/ForgotPassword")
);
const Rules = lazy(() => import("pages/public/Rules/Rules"));
const NotFound = lazy(() => import("pages/NotFound"));

const MAIN = {
    element: (
        <Suspense fallback={<Loader />}>
            <SignInPage />
        </Suspense>
    ),
    path: MAIN_PATH,
};

const SIGNIN = {
    element: (
        <Suspense fallback={<Loader />}>
            <SignInPage />
        </Suspense>
    ),
    path: SIGNIN_PATH,
};

const SIGNUP = {
    element: (
        <Suspense fallback={<Loader />}>
            <SignUpPage />
        </Suspense>
    ),
    path: SIGNUP_PATH,
};

const FORGOT_PASSWORD = {
    element: (
        <Suspense fallback={<Loader />}>
            <ForgotPasswordPage />
        </Suspense>
    ),
    path: FORGOT_PASSWORD_PATH,
};

const RULES = {
    element: (
        <Suspense fallback={<Loader />}>
            <Rules />
        </Suspense>
    ),
    path: RULES_PATH,
};

const NOT_FOUND = {
    element: (
        <Suspense fallback={<Loader />}>
            <NotFound />
        </Suspense>
    ),
    path: ERROR_PAGE_404_PATH,
};

const routes = [MAIN, SIGNIN, SIGNUP, FORGOT_PASSWORD, RULES, NOT_FOUND];

export default routes;
